import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-no-border_7e1e7010aa328f1e7141bd31f5bec859",
  "use": "add-no-border_7e1e7010aa328f1e7141bd31f5bec859-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"add-no-border_7e1e7010aa328f1e7141bd31f5bec859\">\n    <path fill-rule=\"nonzero\" d=\"M14.341 14.341v7.318a2.341 2.341 0 0 1-4.682 0V14.34H2.34a2.341 2.341 0 0 1 0-4.682H9.66V2.34a2.341 2.341 0 0 1 4.682 0V9.66h7.318a2.341 2.341 0 0 1 0 4.682H14.34z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol